import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { t } from '../../../../../../modules/infra/i18n';
import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import { getIsRentalShop } from '../../../../../auth/selectors';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { canUseCommissionReporting, canUserViewBankAccounts } from '../../../../../common/helpers/users';
import { AUTO_PAYOUT_ELIGIBILITY_COMMISSION_SPLIT_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withPermissions,
  connect((state, ownProps) => ({
    isRentalShop: getIsRentalShop(state),
    hasPermissionsToViewCommissionSplits: canUserViewBankAccounts(ownProps.permissions),
    hasConfigurationToViewCommissionSplits: canUseCommissionReporting(state),
  })),
  withProps(() => ({
    name: t('settings:auto_payout.commission_splits_step'),
    description: t('settings:auto_payout.commission_splits_description'),
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_COMMISSION_SPLIT_URL,
    eligibilityActionDescription: t('settings:auto_payout.go_to_commission_splits'),
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      let canPerformAction = true;

      if (props.isRentalShop) {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.no_commission_barbers_error'),
        });

        canPerformAction = false;
      }

      if (!props.hasPermissionsToViewCommissionSplits) {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.no_permissions_error'),
        });

        canPerformAction = false;
      }

      if (!props.hasConfigurationToViewCommissionSplits) {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.missing_configuration_error'),
        });

        canPerformAction = false;
      }

      if (!canPerformAction) {
        return;
      }

      props.router.push('/settings/commission');
    },
  })),
)(AutoPayoutEligibilityStep);
